WiseMetering.Collection.Events = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Event,
    url: '/events',

    comparator: function(event) {
        return -event.get('start');
    }
});
